import React from 'react';
import styled from '@emotion/styled';
import { SwitcherContainer } from 'components/layout/topbar/switcher/switcher-container';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import useStores from 'hooks/use-stores.hooks';
import { typeStyle } from 'constants/typography';

const UserSwitcher: React.FunctionComponent = () => {
  const { authStore } = useStores();
  return (
    <SwitcherContainer>
      <Link to="/personal-settings">
        <MenuItem>
          <FormattedMessage id="personal.settings.menu.personal-settings" />
        </MenuItem>
      </Link>
      <MenuItem onClick={() => authStore.logout()} data-e2e="logout-link">
        <FormattedMessage id="navigation.logout" />
      </MenuItem>
    </SwitcherContainer>
  );
};

const MenuItem = styled.div`
  cursor: pointer;
  padding: 14px 18px;
  ${typeStyle.bodyMd}
  display: flex;
  align-items: center;
  color: var(--text-heading);
  background: var(--surface-main-cards);

  &:hover {
    background: var(--surface-main-element-on-card);
  }
`;

export default UserSwitcher;
